<template>
  <div 
    v-if="selectedNav === '特色农产品'"
    class="category-menu" 
    :class="{ 'menu-open': isMenuOpen }"
  >
    <div class="menu-toggle" @click="toggleMenu">
      <!-- <img :src="icon8" alt="全部品类" class="toggle-icon" /> -->
      <span>{{ currentCategoryName }}</span>
      <i class="arrow" :class="{ 'arrow-up': isMenuOpen }"></i>
    </div>
    <div class="menu-list" v-show="isMenuOpen">
      <div 
        class="menu-item" 
        v-for="(item, index) in categoryList" 
        :key="index"
        :class="{ active: selectedCategory === item.value }"
        @click="handleSelect(item)"
      >
        <img :src="item.icon" alt="" class="menu-icon" />
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
let icon1 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon1.png'
let icon2 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon2.png'
let icon3 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon3.png'
let icon4 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon4.png'
let icon5 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon5.png'
let icon6 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon6.png'
let icon7 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon7.png'
let icon8 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon8.png'
let icon12 =  require('@/assets/icon12.png')

export default {
  name: 'CategoryMenu',
  props: {
    selectedNav: {
      type: String,
      default: ''
    },
    selectedCategory: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMenuOpen: false,
      categoryList: [
        { label: '绿色蔬菜', value: '绿色蔬菜', icon: icon1 },
        { label: '精品花卉', value: '精品花卉', icon: icon2 },
        { label: '优质粮油', value: '优质粮油', icon: icon3 },
        { label: '优新水果', value: '优新水果', icon: icon4 },
        { label: '生态畜禽', value: '生态畜禽', icon: icon5 },
        { label: '现代渔业', value: '现代渔业', icon: icon6 },
        { label: '其他优品', value: '其他优品', icon: icon7 },
        // { label: '马年年货', value: '马年年货', icon: icon12},
        { label: '全部品类', value: '', icon: icon8 }
      ],
      icon8: icon8
    }
  },
  computed: {
    currentCategoryName() {
      if (!this.selectedCategory) {
        return '全部品类'
      }
      const selectedItem = this.categoryList.find(item => item.value === this.selectedCategory)
      return selectedItem ? selectedItem.label : '全部品类'
    }
  },
  watch: {
    selectedNav(newVal) {
      // 当导航切换时，如果不是特色农产品，关闭菜单
      if (newVal !== '特色农产品') {
        this.isMenuOpen = false
      }
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    handleSelect(item) {
      this.isMenuOpen = false
      this.$emit('category-select', item.value)
    }
  }
}
</script>

<style scoped>
/* 右下角分类选择菜单 */
.category-menu {
  position: fixed;
  right: 20px;
  bottom: 330px;
  z-index: 1000;
  display: flex;
  flex-direction: column-reverse;
}

.menu-toggle {
  background-color: #eefff9;
  border-radius: 8px;
  padding: 12px 16px;
  width: 210px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  justify-content: space-between;
}

.menu-toggle .toggle-icon {
  width: 32px;
  height: 35px;
  object-fit: contain;
}

.menu-toggle span {
  color: #004e44;
  font-size: 26px;
  font-weight: 500;
  flex: 1;
}

.menu-toggle .arrow {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #004e44;
  transition: transform 0.3s;
}

.menu-toggle .arrow.arrow-up {
  transform: rotate(180deg);
}

.menu-list {
  margin-bottom: 8px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  min-width: 200px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.menu-item.active {
  background-color: #eefff9;
}

.menu-item .menu-icon {
  width: 40px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

.menu-item span {
  color: #333;
  font-size: 26px;
  flex: 1;
}

.menu-item.active span {
  color: #004e44;
  font-weight: 500;
}
</style>

